import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CONTACT } from "../data/content";
import { EmailWithCopy } from "../components/site/ContactFormDialog";

const Bloc = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-serif text-2xl text-[#2E2A22]">{title}</h2>
    <div className="mt-4 space-y-3 text-sm text-[#6B6355] leading-relaxed">{children}</div>
  </section>
);

export default function MentionsLegales() {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div data-testid="mentions-page" className="min-h-screen bg-[#FBF7EF] text-[#2E2A22]" style={{ fontFamily: "Manrope, sans-serif" }}>
      <header className="max-w-3xl mx-auto px-6 pt-8 flex items-center justify-between">
        <Link to="/">
          <img src="/logo-tpoz.jpg" alt="T'POZ" className="h-16 sm:h-20 w-auto mix-blend-multiply" />
        </Link>
        <Link
          to="/"
          data-testid="mentions-back-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-[#A66E08] hover:text-[#C6870F] transition-colors"
        >
          <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#A66E08]">T'POZ</p>
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl" data-testid="mentions-title">
          Mentions légales &amp; confidentialité
        </h1>

        <Bloc title="Éditeur du site">
          <p>
            Le site T'POZ est édité par l'association <strong>Plus Belle La Vie 971</strong>,
            association loi 1901, dont le siège est situé : {CONTACT.address}.
          </p>
          <p>
            Contact :{" "}
            <EmailWithCopy testId="mentions-email" className="text-[#A66E08]" />{" "}
            · {CONTACT.phone}
          </p>
          <p>Directrice de la publication : la présidente de l'association Plus Belle La Vie 971.</p>
        </Bloc>

        <Bloc title="Hébergement">
          <p>
            Le site est hébergé par la plateforme Emergent (emergent.sh). Les données sont stockées
            de manière sécurisée.
          </p>
        </Bloc>

        <Bloc title="Objet du site">
          <p>
            T'POZ est un réseau solidaire de répit et de ressourcement destiné aux femmes à partir de
            40 ans en Guadeloupe. Le site présente le réseau, ses partenaires, et permet de déposer
            une demande de bon T'POZ.
          </p>
        </Bloc>

        <Bloc title="Données personnelles (RGPD)">
          <p>
            Les informations collectées via les formulaires du site (demande de bon T'POZ,
            candidature partenaire, contact) sont destinées exclusivement à l'association Plus Belle
            La Vie 971, responsable de traitement, afin de gérer votre demande et le suivi du
            réseau T'POZ. Elles ne sont ni vendues ni transmises à des tiers.
          </p>
          <p>
            Les données sont conservées pendant la durée nécessaire au traitement de votre demande
            et au maximum 3 ans après le dernier contact.
          </p>
          <p>
            Conformément au Règlement général sur la protection des données (RGPD) et à la loi
            Informatique et Libertés, vous disposez d'un droit d'accès, de rectification,
            d'opposition, de limitation et de suppression de vos données. Pour l'exercer,
            écrivez-nous à{" "}
            <EmailWithCopy testId="mentions-rgpd-email" className="text-[#A66E08]" />
            .
          </p>
        </Bloc>

        <Bloc title="Cookies">
          <p>
            Le site n'utilise pas de cookies publicitaires ni de traceurs à des fins commerciales.
            Seuls des cookies techniques strictement nécessaires au fonctionnement du site peuvent
            être déposés.
          </p>
        </Bloc>

        <Bloc title="Propriété intellectuelle">
          <p>
            L'ensemble des contenus du site (textes, visuels, logos T'POZ et Plus Belle La Vie 971)
            est protégé. Toute reproduction, totale ou partielle, sans autorisation écrite préalable
            de l'association est interdite.
          </p>
        </Bloc>

        <Bloc title="Responsabilité">
          <p>
            Les expériences T'POZ sont proposées par des partenaires indépendants. Les informations
            publiées (tarifs solidaires, disponibilités, prestations) sont fournies par les
            partenaires et peuvent évoluer ; elles sont confirmées au moment de la réservation.
            T'POZ ne propose pas de soins médicaux ou psychologiques.
          </p>
        </Bloc>

        <p className="mt-16 text-xs text-[#6B6355]/60">
          Dernière mise à jour : juin 2026 · © 2026 T'POZ — Association Plus Belle La Vie 971
        </p>
      </main>
    </div>
  );
}
